import { ArcadePage, type ArcadeSpec } from "./ArcadeShell";
import { tk } from "../../../../lib/i18n";

const SPEC: ArcadeSpec = {
  id: "kart", title: tk("Kart Kuiz"), tone: "from-sky-500 to-indigo-600", emoji: "🏎️", w: 360, h: 520, mascot: true,
  intro: tk("Pandu kart bersama Harraz atau Hannah! Pilih lorong dengan jawapan betul untuk dapat boost. Jawapan salah akan buat kart berpusing."),
  load: async () => (await import("./engines/kart3d")).createKart3d,
};
export const KartKuizPage = () => <ArcadePage spec={SPEC} />;
